import React from 'react';
import { Button } from '@ktag/styleguide/dist/react';
import { Sprite } from '@agissc/ktag-map';
import { useTranslation } from 'react-i18next';
import useAppState from '../../AppStore';
import SelectedTopicLayers from './topics/SelectedTopicLayers';
import BasemapSelection from './BasemapSelection';
import { useTracking } from '../../utils/tracking/TrackingContext';

const MapContent = () => {
  const { t } = useTranslation('agisviewer');
  const { Tracking } = useTracking();
  const setActiveView = useAppState((state) => state.setActiveView);
  const selectedTopicLayers = useAppState((state) => state.selectedTopicLayers);

  const onClick = () => {
    Tracking.Topics.openAddTopicView();
    setActiveView('mapContent_tool_add_topic');
  };

  return (
    <div className="tooldialog__wrapper">
      <div className="tooldialog__wrapper-content">
        <Button
          additionalClassNames="button__max-width"
          label={t('add_topic')}
          onClick={onClick}
        />
        {selectedTopicLayers.length === 0 && (
          <p>
            <Sprite id="i-circle" additionalClassNames="legend__icon" />{' '}
            {t('no_topic_added')}
          </p>
        )}
      </div>
      {selectedTopicLayers.length > 0 && <SelectedTopicLayers />}
      <BasemapSelection />
    </div>
  );
};

export default MapContent;
